<template>
    <div class="setting-content--section">
        <b-form @submit="onSubmit">
            {{ $gettext('By clicking the "Delete" button at the end of this page, you are making a request to delete all your information stored on this website.') }}
            <br>
            {{ $gettext('The following will be permanently deleted from the Gekko databases:') }}
            <ul>
                <li>
                    {{ $gettext('Your profile.') }}
                </li>
                <li>
                    {{ $gettext('The companies for which you are an owner.') }}
                </li>
                <li>
                    {{ $gettext('All media related to this account.') }}
                </li>
                <li>
                    {{ $gettext('All your invoices, costs, expenses, etc.') }}
                </li>
            </ul>
            {{ $gettext('This is the deletion procedure:') }}
            <ol>
                <li>
                    {{ $gettext('Click Delete on the bottom of this page.') }}
                </li>
                <li>
                    {{ $gettext('Receive a confirmation E-mail and click on the link to initiate the deletion procedure.') }}
                </li>
                <li>
                    {{ $gettext('In 4 days, a final e-mail will be sent in case you still wish to download your data.') }}
                </li>
                <li>
                    {{ $gettext('After 5 days, your account and all data on it will be deleted.') }}
                </li>
            </ol>
            {{ $gettext('Please remember to save all your important data from your account before it is deleted, as there is no way to recover the information once the deletion procedure has completed.') }}
            <br>
            {{ $gettext('If you change your mind and choose to stop the deletion procedure, you will be able to do this by clicking on the red bar that will appear on top of the page once the deletion procedure starts.') }}
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <label>{{ $gettext('Password*') }}</label>
                        <b-form-input type="password" id="text-password" v-model="form.password"
                            :placeholder="$gettext('Password...')" required>
                        </b-form-input>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <label>{{ $gettext('Reason*') }}</label>
                        <b-form-textarea id="text-reason" v-model="form.reason" :placeholder="$gettext('Enter your reason here...')"
                            required></b-form-textarea>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <b-button type="submit" variant="primary">{{ $gettext('Delete') }}</b-button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import UserService from "@/store/services/user.service.js";
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "AccountDelete",
    components: {},
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Delete profile"),
                showCompanyPicker: false
            },
            form: {
                password: null,
                reason: null,
            },
        }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();
            var encryptedPassword = window.btoa(this.form.password);
            UserService.deleteAccount({ password: encryptedPassword, reason: this.form.reason }).then((response) => {
                if (response.status == 200) {
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Success"),
                        text: this.$gettext("Successfully started the deletion procedure. Please check your e-mail for confirmation!"),
                        variant: "success",
                        duration: 4
                    });
                }
            }).catch((response) => {
                switch (response.status) {
                    case 400:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Too soon"),
                            text: this.$gettext("You have changed your email address less than two weeks ago. Please try again later."),
                            variant: "danger",
                            duration: 4
                        });
                        break;
                    case 403:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Wrong password"),
                            text: this.$gettext("Your password is incorrect. Please enter the correct password."),
                            variant: "danger",
                            duration: 4
                        });
                        break;
                    case 500:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Something went wrong"),
                            text: this.$gettext("Something went wrong when trying to delete your account. Please try again later."),
                            variant: "danger",
                            duration: 4
                        });
                        break;
                }
            });
            event.preventDefault();
        }
    }
};
</script>

<style >

</style>
